import React, { useState } from 'react';
import SbEditable from 'storyblok-react';
import RichTextRenderer from '~/components/Dynamic/RichTextRenderer';

function FaqItem({ blok, className, showAnswer = false, idx, expanded, setExpanded }) {
  const isOpen = idx === expanded;

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className={`faq-item ${className}`}>
        <div className={`${!isOpen && 'opacity-50'} hover:opacity-100 transition-opacity duration-300 pr-12`}>
          <header
            onClick={() => setExpanded(isOpen ? false : idx)}
            className={`cursor-pointer select-none py-8 md:py-12 ${isOpen && '!pb-0 md:pb-0 is-selected'}`}>
            <h3
              className="font-bold leading-snug text-28px font-heading "
              dangerouslySetInnerHTML={{ __html: blok.heading }}
            />
          </header>
          {isOpen && (
            <div className="mt-4">
              <div className="leading-normal tracking-tighter text-20px">
                <RichTextRenderer content={blok.content} />
              </div>
            </div>
          )}
        </div>

        <div className={`${isOpen && 'mt-12'}`}>
          <div className="border-t border-black"></div>
        </div>
      </div>
    </SbEditable>
  );
}

export default FaqItem;
